import React from 'react';

function house_farms() {
	return (
		<div class="col-md-10 house_farms">
			<div class="greeting">
				<img src={`${process.env.PUBLIC_URL}/images/panel2.png`} />
				<img src={`${process.env.PUBLIC_URL}/images/gdmobile.png`} />
			</div>
			<div class="row">
				<div class="col-md-12">
					<h3>Stake LP Tokens to Earn Coin</h3>
					<p class="activebar">
						<a href="#" class="bluelink">Active</a>
						<a href="#" class="greylink">Inactive</a>
					</p>
					<p class="onoff">
						<span>Staked Only</span>
						<img src={`${process.env.PUBLIC_URL}/images/onoff.png`} />
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
				  <div class="inner">
					<div class="cointop">
					<img class="floatRight" src={`${process.env.PUBLIC_URL}/images/coinpic.png`} />
					<h3>COIN-BUSD LP</h3>
					<p><span class="xfactor">60X</span><span class="nofee">No fee</span></p>
					</div>
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<div class="coinmiddle">
					<p>ARR<span>124.44%</span></p>
					<p>Stake<span>EGG-BUSD LP</span></p>
					<p>Earn<span>EGG</span></p>
					<p>Deposit Fee<span>0%</span></p>
					</div>
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<div class="coinbottom">
					<p class="left">EGG EARN:<strong>0</strong><a href="#" class="harvest floatRight">Harvest</a></p>
					<p class="links"><a href="#" class="yellow">Unlock Wallet</a>
						<a href="#"><img src={`${process.env.PUBLIC_URL}/images/seemore.png`} /></a>
					</p>
					</div>
				  </div>
				</div>
				<div class="col-md-4">
				  <div class="inner">
					<div class="cointop">
					<img class="floatRight" src={`${process.env.PUBLIC_URL}/images/coinpic.png`} />
					<h3>COIN-BNB LP</h3>
					<p><span class="xfactor">60X</span><span class="nofee">No fee</span></p>
					</div>
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<div class="coinmiddle">
					<p>ARR<span>124.44%</span></p>
					<p>Stake<span>EGG-BUSD LP</span></p>
					<p>Earn<span>EGG</span></p>
					<p>Deposit Fee<span>0%</span></p>
					</div>
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<div class="coinbottom">
					<p class="left">EGG EARN:<strong>0</strong><a href="#" class="harvest floatRight">Harvest</a></p>
					<p class="links"><a href="#" class="yellow">Unlock Wallet</a>
						<a href="#"><img src={`${process.env.PUBLIC_URL}/images/seemore.png`} /></a>
					</p>
					</div>
				  </div>
				</div>
				<div class="col-md-4">
				  <div class="inner">
					<div class="cointop">
					<img class="floatRight" src={`${process.env.PUBLIC_URL}/images/coinpic.png`} />
					<h3>TYPH-BUSD LP</h3>
					<p><span class="xfactor">60X</span><span class="nofee">No fee</span></p>
					</div>
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<div class="coinmiddle">
					<p>ARR<span>124.44%</span></p>
					<p>Stake<span>EGG-BUSD LP</span></p>
					<p>Earn<span>EGG</span></p>
					<p>Deposit Fee<span>0%</span></p>
					</div>
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<div class="coinbottom">
					<p class="left">EGG EARN:<strong>0</strong><a href="#" class="harvest floatRight">Harvest</a></p>
					<p class="links"><a href="#" class="yellow">Unlock Wallet</a>
						<a href="#"><img src={`${process.env.PUBLIC_URL}/images/seemore.png`} /></a>
					</p>
					</div>
				  </div>
				</div>
			</div>
		</div>
	);
}

export default house_farms;
			